<template>
  <div class="invoice-dense-tab">
    <div class="invoice-dense-table-wrap">
      <b-table
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        hover
        responsive
        small
        :busy="loading"
        show-empty
        class="invoice-dense-table mb-0"
      >
        <template #table-busy>
          <div class="invoice-dense-state invoice-dense-state--loading">
            <b-spinner small class="mr-50" />
            <span>Loading compliance data…</span>
          </div>
        </template>
        <template #empty>
          <div class="invoice-dense-state">
            <div class="invoice-dense-empty-icon">
              <feather-icon icon="ShieldIcon" size="28" />
            </div>
            <h6 class="mb-25">No compliance data</h6>
            <p class="text-muted mb-1">
              {{ searchActive ? 'Try a different search or clear it.' : 'No e-invoice / GST compliance rows for this period.' }}
            </p>
            <b-button v-if="searchActive" size="sm" variant="outline-secondary" @click="$emit('clear-search')">
              Clear search
            </b-button>
          </div>
        </template>
        <template #cell(invoice_id)="{ item }">
          <div class="inv-cell-stack">
            <span class="inv-primary-text text-nowrap">{{ item.invoice_id || 'N/A' }}</span>
            <small class="text-muted text-nowrap">{{ formatDate(item.invoice_date) || 'N/A' }}</small>
          </div>
        </template>
        <template #cell(einvoice_filed)="{ item }">
          <div class="d-flex flex-column align-items-start">
            <b-badge :variant="item.einvoice_filed ? 'success' : 'warning'" class="inv-status-badge mb-50">
              <feather-icon :icon="item.einvoice_filed ? 'CheckCircleIcon' : 'ClockIcon'" size="11" class="mr-25" />
              {{ item.einvoice_filed ? 'Filed' : 'Pending' }}
            </b-badge>
            <small v-if="item.einvoice_filed && item.einvoice_date" class="text-muted mb-25">{{ item.einvoice_date }}</small>
            <b-button
              size="sm"
              variant="flat-primary"
              class="p-0"
              style="font-size:0.7rem; height:auto;"
              v-b-tooltip.hover="'Update E-Invoice Status'"
              @click="$emit('update-einvoice', item)"
            >
              <feather-icon icon="RefreshCwIcon" size="11" class="mr-25" />
              Update
            </b-button>
          </div>
        </template>
        <template #cell(tds_applicable)="{ item }">
          <b-badge :variant="item.tds_applicable ? 'info' : 'secondary'" class="inv-status-badge">
            {{ item.tds_applicable ? 'Yes' : 'No' }}
          </b-badge>
        </template>
      </b-table>
    </div>
    <div v-if="totalRows > perPage" class="invoice-dense-pagination">
      <b-pagination
        :value="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        size="sm"
        @change="$emit('page-change', $event)"
      />
    </div>
  </div>
</template>

<script>
import { BTable, BBadge, BButton, BSpinner, BPagination, VBTooltip } from 'bootstrap-vue'
import invoiceFormatMixin from '@/mixins/invoiceFormatMixin'

export default {
  name: 'ReconComplianceTab',
  components: { BTable, BBadge, BButton, BSpinner, BPagination },
  directives: { 'b-tooltip': VBTooltip },
  mixins: [invoiceFormatMixin],
  props: {
    items: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    perPage: { type: Number, default: 10 },
    currentPage: { type: Number, default: 1 },
    totalRows: { type: Number, default: 0 },
    searchActive: { type: Boolean, default: false }
  },
  emits: ['page-change', 'update-einvoice', 'clear-search']
}
</script>

<style lang="scss">
@import '../tabs/invoice-dense-tab.scss';
</style>
